// source: participantsession/participantsession.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_api_annotations_pb = require('../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_api_client_pb = require('../google/api/client_pb.js');
goog.object.extend(proto, google_api_client_pb);
var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js');
goog.object.extend(proto, google_api_field_behavior_pb);
var google_api_resource_pb = require('../google/api/resource_pb.js');
goog.object.extend(proto, google_api_resource_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_type_interval_pb = require('../google/type/interval_pb.js');
goog.object.extend(proto, google_type_interval_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var common_historyinformation_pb = require('../common/historyinformation_pb.js');
goog.object.extend(proto, common_historyinformation_pb);
var common_fieldchangelog_pb = require('../common/fieldchangelog_pb.js');
goog.object.extend(proto, common_fieldchangelog_pb);
goog.exportSymbol('proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest', null, global);
goog.exportSymbol('proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest', null, global);
goog.exportSymbol('proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest', null, global);
goog.exportSymbol('proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest', null, global);
goog.exportSymbol('proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse', null, global);
goog.exportSymbol('proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest', null, global);
goog.exportSymbol('proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest', null, global);
goog.exportSymbol('proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest', null, global);
goog.exportSymbol('proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest', null, global);
goog.exportSymbol('proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse', null, global);
goog.exportSymbol('proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest', null, global);
goog.exportSymbol('proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse', null, global);
goog.exportSymbol('proto.verily.sdp.participantsession.v1alpha1.ParticipantSession', null, global);
goog.exportSymbol('proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog', null, global);
goog.exportSymbol('proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.participantsession.v1alpha1.ParticipantSession, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.displayName = 'proto.verily.sdp.participantsession.v1alpha1.ParticipantSession';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest.displayName = 'proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest.displayName = 'proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest.displayName = 'proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.displayName = 'proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.displayName = 'proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.repeatedFields_, null);
};
goog.inherits(proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.displayName = 'proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.displayName = 'proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.repeatedFields_, null);
};
goog.inherits(proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.displayName = 'proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.displayName = 'proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse.displayName = 'proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest.displayName = 'proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest.displayName = 'proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest.displayName = 'proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.repeatedFields_, null);
};
goog.inherits(proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.displayName = 'proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSession} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    deviceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    deviceSessionId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    interval: (f = msg.getInterval()) && google_type_interval_pb.Interval.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSession}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.participantsession.v1alpha1.ParticipantSession;
  return proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSession} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSession}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDeviceSessionId(value);
      break;
    case 4:
      var value = new google_type_interval_pb.Interval;
      reader.readMessage(value,google_type_interval_pb.Interval.deserializeBinaryFromReader);
      msg.setInterval(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSession} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDeviceSessionId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getInterval();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_interval_pb.Interval.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSession} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string device_id = 2;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSession} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.prototype.setDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 device_session_id = 3;
 * @return {number}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.prototype.getDeviceSessionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSession} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.prototype.setDeviceSessionId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.type.Interval interval = 4;
 * @return {?proto.google.type.Interval}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.prototype.getInterval = function() {
  return /** @type{?proto.google.type.Interval} */ (
    jspb.Message.getWrapperField(this, google_type_interval_pb.Interval, 4));
};


/**
 * @param {?proto.google.type.Interval|undefined} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSession} returns this
*/
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.prototype.setInterval = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSession} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.prototype.clearInterval = function() {
  return this.setInterval(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.prototype.hasInterval = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    participantSession: (f = msg.getParticipantSession()) && proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest;
  return proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.verily.sdp.participantsession.v1alpha1.ParticipantSession;
      reader.readMessage(value,proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.deserializeBinaryFromReader);
      msg.setParticipantSession(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParticipantSession();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.serializeBinaryToWriter
    );
  }
};


/**
 * optional ParticipantSession participant_session = 1;
 * @return {?proto.verily.sdp.participantsession.v1alpha1.ParticipantSession}
 */
proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest.prototype.getParticipantSession = function() {
  return /** @type{?proto.verily.sdp.participantsession.v1alpha1.ParticipantSession} */ (
    jspb.Message.getWrapperField(this, proto.verily.sdp.participantsession.v1alpha1.ParticipantSession, 1));
};


/**
 * @param {?proto.verily.sdp.participantsession.v1alpha1.ParticipantSession|undefined} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest} returns this
*/
proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest.prototype.setParticipantSession = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest.prototype.clearParticipantSession = function() {
  return this.setParticipantSession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.verily.sdp.participantsession.v1alpha1.CreateParticipantSessionRequest.prototype.hasParticipantSession = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest;
  return proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.GetParticipantSessionRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updateReason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest;
  return proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string update_reason = 2;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest.prototype.getUpdateReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.DeleteParticipantSessionRequest.prototype.setUpdateReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    endTime: (f = msg.getEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateReason: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest;
  return proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndTime(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEndTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp end_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.prototype.getEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest} returns this
*/
proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.prototype.setEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.prototype.clearEndTime = function() {
  return this.setEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.prototype.hasEndTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string update_reason = 3;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.prototype.getUpdateReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.EndParticipantSessionRequest.prototype.setUpdateReason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    parent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest;
  return proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParent(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string parent = 1;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.prototype.getParent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.prototype.setParent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_size = 2;
 * @return {number}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string page_token = 3;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionsList: jspb.Message.toObjectList(msg.getSessionsList(),
    proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse;
  return proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.verily.sdp.participantsession.v1alpha1.ParticipantSession;
      reader.readMessage(value,proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.deserializeBinaryFromReader);
      msg.addSessions(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated ParticipantSession sessions = 1;
 * @return {!Array<!proto.verily.sdp.participantsession.v1alpha1.ParticipantSession>}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.prototype.getSessionsList = function() {
  return /** @type{!Array<!proto.verily.sdp.participantsession.v1alpha1.ParticipantSession>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.verily.sdp.participantsession.v1alpha1.ParticipantSession, 1));
};


/**
 * @param {!Array<!proto.verily.sdp.participantsession.v1alpha1.ParticipantSession>} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse} returns this
*/
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.prototype.setSessionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSession=} opt_value
 * @param {number=} opt_index
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSession}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.prototype.addSessions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.verily.sdp.participantsession.v1alpha1.ParticipantSession, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.prototype.clearSessionsList = function() {
  return this.setSessionsList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionsResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    registryId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    studySiteId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    swapMapMap: (f = msg.getSwapMapMap()) ? f.toObject(includeInstance, undefined) : [],
    updateReason: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest;
  return proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegistryId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStudySiteId(value);
      break;
    case 3:
      var value = msg.getSwapMapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegistryId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStudySiteId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSwapMapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getUpdateReason();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string registry_id = 1;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.prototype.getRegistryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.prototype.setRegistryId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string study_site_id = 2;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.prototype.getStudySiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.prototype.setStudySiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * map<string, string> swap_map = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.prototype.getSwapMapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.prototype.clearSwapMapMap = function() {
  this.getSwapMapMap().clear();
  return this;};


/**
 * optional string update_reason = 4;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.prototype.getUpdateReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.SwapParticipantSessionsRequest.prototype.setUpdateReason = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.toObject = function(includeInstance, msg) {
  var f, obj = {
    participantSession: (f = msg.getParticipantSession()) && proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.toObject(includeInstance, f),
    sponsorParticipantId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fieldChangeLogsList: jspb.Message.toObjectList(msg.getFieldChangeLogsList(),
    common_fieldchangelog_pb.FieldChangeLog.toObject, includeInstance),
    historyInformation: (f = msg.getHistoryInformation()) && common_historyinformation_pb.HistoryInformation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog;
  return proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.verily.sdp.participantsession.v1alpha1.ParticipantSession;
      reader.readMessage(value,proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.deserializeBinaryFromReader);
      msg.setParticipantSession(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSponsorParticipantId(value);
      break;
    case 3:
      var value = new common_fieldchangelog_pb.FieldChangeLog;
      reader.readMessage(value,common_fieldchangelog_pb.FieldChangeLog.deserializeBinaryFromReader);
      msg.addFieldChangeLogs(value);
      break;
    case 4:
      var value = new common_historyinformation_pb.HistoryInformation;
      reader.readMessage(value,common_historyinformation_pb.HistoryInformation.deserializeBinaryFromReader);
      msg.setHistoryInformation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParticipantSession();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.verily.sdp.participantsession.v1alpha1.ParticipantSession.serializeBinaryToWriter
    );
  }
  f = message.getSponsorParticipantId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFieldChangeLogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_fieldchangelog_pb.FieldChangeLog.serializeBinaryToWriter
    );
  }
  f = message.getHistoryInformation();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_historyinformation_pb.HistoryInformation.serializeBinaryToWriter
    );
  }
};


/**
 * optional ParticipantSession participant_session = 1;
 * @return {?proto.verily.sdp.participantsession.v1alpha1.ParticipantSession}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.getParticipantSession = function() {
  return /** @type{?proto.verily.sdp.participantsession.v1alpha1.ParticipantSession} */ (
    jspb.Message.getWrapperField(this, proto.verily.sdp.participantsession.v1alpha1.ParticipantSession, 1));
};


/**
 * @param {?proto.verily.sdp.participantsession.v1alpha1.ParticipantSession|undefined} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog} returns this
*/
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.setParticipantSession = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.clearParticipantSession = function() {
  return this.setParticipantSession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.hasParticipantSession = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string sponsor_participant_id = 2;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.getSponsorParticipantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.setSponsorParticipantId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated verily.sdp.common.v1alpha1.FieldChangeLog field_change_logs = 3;
 * @return {!Array<!proto.verily.sdp.common.v1alpha1.FieldChangeLog>}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.getFieldChangeLogsList = function() {
  return /** @type{!Array<!proto.verily.sdp.common.v1alpha1.FieldChangeLog>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_fieldchangelog_pb.FieldChangeLog, 3));
};


/**
 * @param {!Array<!proto.verily.sdp.common.v1alpha1.FieldChangeLog>} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog} returns this
*/
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.setFieldChangeLogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.verily.sdp.common.v1alpha1.FieldChangeLog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.verily.sdp.common.v1alpha1.FieldChangeLog}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.addFieldChangeLogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.verily.sdp.common.v1alpha1.FieldChangeLog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.clearFieldChangeLogsList = function() {
  return this.setFieldChangeLogsList([]);
};


/**
 * optional verily.sdp.common.v1alpha1.HistoryInformation history_information = 4;
 * @return {?proto.verily.sdp.common.v1alpha1.HistoryInformation}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.getHistoryInformation = function() {
  return /** @type{?proto.verily.sdp.common.v1alpha1.HistoryInformation} */ (
    jspb.Message.getWrapperField(this, common_historyinformation_pb.HistoryInformation, 4));
};


/**
 * @param {?proto.verily.sdp.common.v1alpha1.HistoryInformation|undefined} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog} returns this
*/
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.setHistoryInformation = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.clearHistoryInformation = function() {
  return this.setHistoryInformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.prototype.hasHistoryInformation = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    deviceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    registryId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    studySiteId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest;
  return proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegistryId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStudySiteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRegistryId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStudySiteId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string device_id = 1;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.prototype.setDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string registry_id = 2;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.prototype.getRegistryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.prototype.setRegistryId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string study_site_id = 3;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.prototype.getStudySiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdRequest.prototype.setStudySiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    endTime: (f = msg.getEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse}
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse;
  return proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse}
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp end_time = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse.prototype.getEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse} returns this
*/
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse.prototype.setEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse.prototype.clearEndTime = function() {
  return this.setEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.verily.sdp.participantsession.v1alpha1.GetMostRecentEndTimeByDeviceIdResponse.prototype.hasEndTime = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    registryId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest;
  return proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegistryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegistryId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string registry_id = 1;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest.prototype.getRegistryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByRegistryIdRequest.prototype.setRegistryId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    studySiteId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest;
  return proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStudySiteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStudySiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string study_site_id = 1;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest.prototype.getStudySiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudySiteIdRequest.prototype.setStudySiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    studyParticipantId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest;
  return proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStudyParticipantId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStudyParticipantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string study_participant_id = 1;
 * @return {string}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest.prototype.getStudyParticipantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsByStudyParticipantIdRequest.prototype.setStudyParticipantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    participantSessionChangeLogsList: jspb.Message.toObjectList(msg.getParticipantSessionChangeLogsList(),
    proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse;
  return proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog;
      reader.readMessage(value,proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.deserializeBinaryFromReader);
      msg.addParticipantSessionChangeLogs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParticipantSessionChangeLogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ParticipantSessionChangeLog participant_session_change_logs = 1;
 * @return {!Array<!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog>}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.prototype.getParticipantSessionChangeLogsList = function() {
  return /** @type{!Array<!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog, 1));
};


/**
 * @param {!Array<!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog>} value
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse} returns this
*/
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.prototype.setParticipantSessionChangeLogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog}
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.prototype.addParticipantSessionChangeLogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.verily.sdp.participantsession.v1alpha1.ParticipantSessionChangeLog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse} returns this
 */
proto.verily.sdp.participantsession.v1alpha1.ListParticipantSessionChangeLogsResponse.prototype.clearParticipantSessionChangeLogsList = function() {
  return this.setParticipantSessionChangeLogsList([]);
};


goog.object.extend(exports, proto.verily.sdp.participantsession.v1alpha1);
